/**
 * @Description Reducer for Exceptions
 * @FileName ExceptionsFilter.js
 * @Author Anuj Vishwakarma - vishanu
 * @CreatedOn 26 September, 2022 04:15:36
 */

import { basicFilterInitialState } from '../../../../../stateManagement/reduxUtil';
import { commonTypes } from '../../../../common/redux/actions/commonActions';
import { eiActionTypes } from '../actions/actionTypes';

export const FILTER_REDUCER_NAME = 'ExceptionsFilterList';

const updateFilterConfig = (state, action) => {
  const selectedFilter = (action.data && action.data.selectedItem) || null;
  if (action.data) {
    if (action.data.systemDefault) {
      return {
        ...state,
        selectedFilter,
        systemDefaultFilter: action.data.systemDefault || null,
        userDefaultFilter: action.data.userDefault || null,
      };
    }
    if (action.data.userDefault === null || action.data.userDefault) {
      return {
        ...state,
        selectedFilter,
        userDefaultFilter: action.data.userDefault,
      };
    }
  }
  return {
    ...state,
    selectedFilter,
  };
};

const updateFilterOption = (state, action) => ({
  ...state,
  listParamOptions: action.data ? action.data.detail.parameters : null,
  listSortOptions: action.data ? action.data.detail.sortOptions : null,
  listColumnOrder: action.data ? action.data.detail.columnOrders : null,
  listGroupBy: action.data ? action.data.detail.groupByParameters : null,
  isDistinctActive: action.data ? action.data.detail.isDistinct : null,
  selectedFilter: action.data ? action.data : null,
});

const logExceptionsListRequest = (state, action) => ({
  ...state,
  listRequest: action.data ? action.data : state.listRequest,
  listRequestedOn: new Date(),
  loading: true,
});

const resetServerValue = (state, action) => ({
  ...state,
  serverRequestError: action.data && action.data.serverRequestError,
  loading: false,
});

const getEditItemDetailsResponse = (state, action) => ({
  ...state,
  getEditItemDetails: action.data,
});

const SubExceptionFilterList = (state, action) => {
  switch (action.type) {
    case eiActionTypes.RESET_SERVER_VALUE:
      return resetServerValue(state, action);
    case commonTypes.RESETSTORE:
      return basicFilterInitialState;
    default:
      return state;
  }
};
const ExceptionsFilterList = (state = { ...basicFilterInitialState }, action = null) => {
  switch (action.type) {
    case eiActionTypes.UPDATE_FILTER_CONFIG:
      return updateFilterConfig(state, action);
    case eiActionTypes.REMOVE_USER_DEFAULT_FILTER:
      return {
        ...state,
        userDefaultFilter: null,
      };
    case eiActionTypes.UPDATE_TABLE_CONFIGURATION:
      return updateFilterOption(state, action);
    case eiActionTypes.LOG_EXI_LIST_REQUEST:
      return logExceptionsListRequest(state, action);
    case eiActionTypes.GET_EXI_BY_ID_RESPONSE:
      return getEditItemDetailsResponse(state, action);
    case eiActionTypes.GET_EXI_LIST_ERROR:
      return {
        ...state,
        listRequestError: action.data,
        listRequestProcessedOn: new Date(),
        loading: false,
      };
    case eiActionTypes.GET_EXI_LIST_RESPONSE:
      return {
        ...state,
        listData: action.data,
        listRequestError: null,
        listRequestProcessedOn: new Date(),
        loading: false,
      };

    case eiActionTypes.RESET_EXI_STORE:
      return {
        ...state,
        listData: null,
        listRequestError: null,
        listRequestProcessedOn: null,
        serverRequestError: null,
        loading: false,
      };
    default:
      return SubExceptionFilterList(state, action);
  }
};

export default ExceptionsFilterList;
